import { jsx as e, jsxs as $ } from "react/jsx-runtime";
import { clsx as g } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { remCalc as R } from "../../style/base/index.js";
import { RocheUIIcon as k } from "../icon/roche-icon.js";
import a from "./roche-pagination.module.scss.js";
const I = "…", w = ({ label: n }) => /* @__PURE__ */ e("span", { className: a["pagination__item-text"], "aria-hidden": "true", children: n }), S = ({ enabled: n, onClick: i, onFocus: t, icon: l, label: o }) => /* @__PURE__ */ e(
  "li",
  {
    className: g(
      {
        [a["pagination__item--disabled"]]: !n
      },
      a.pagination__item,
      a["pagination__item--colored"]
    ),
    children: /* @__PURE__ */ e(
      "button",
      {
        className: a.pagination__button,
        onClick: i,
        onFocus: () => t == null ? void 0 : t(),
        onMouseEnter: () => t == null ? void 0 : t(),
        disabled: !n,
        "aria-disabled": !n,
        "aria-label": o,
        type: "button",
        children: /* @__PURE__ */ e("span", { className: a.pagination__icon, children: /* @__PURE__ */ e(k, { icon: l, width: `${R(24)}rem`, height: `${R(24)}rem` }) })
      }
    )
  }
), j = ({
  page: n,
  isActive: i,
  setPage: t,
  focusPage: l,
  pageLabel: o,
  currentPageLabel: r
}) => {
  const p = `${o} ${n}`, u = i ? `${p}, ${r}` : p;
  return /* @__PURE__ */ e(
    "li",
    {
      className: g(
        a["pagination__large-numbers"],
        a.pagination__item,
        a["pagination__item--colored"],
        {
          [a["pagination__item--active"]]: i
        }
      ),
      children: /* @__PURE__ */ e(
        "button",
        {
          className: a.pagination__button,
          onClick: () => t(n),
          onMouseOver: () => {
            l && !i && l(n);
          },
          onFocus: () => {
            l && !i && l(n);
          },
          "aria-current": i ? "page" : void 0,
          "aria-label": u,
          tabIndex: i ? -1 : void 0,
          type: "button",
          children: /* @__PURE__ */ e(w, { label: n })
        }
      )
    },
    `page-${n}`
  );
}, C = ({ index: n }) => /* @__PURE__ */ e(
  "li",
  {
    className: g(a["pagination__large-numbers"], a["pagination__item--disabled"], a.pagination__item),
    "aria-hidden": "true",
    role: "presentation",
    children: /* @__PURE__ */ e("span", { className: a["pagination__item-text"], children: I })
  },
  `ellipsis-${n}`
), L = (n, i) => Array.from({ length: i - n }, (t, l) => l + n), G = (n, i, t) => {
  const { floor: l, min: o, max: r } = Math;
  if (t <= n)
    return L(1, t + 1);
  const p = n - 4, u = l(p / 2);
  let m = r(2, i - u), c = o(t - 1, i + u), _ = m - 2, d = t - 1 - c;
  if (_ <= 1 && d > 1) {
    m = 2;
    const b = m + n - 4;
    c = r(b, i + 1);
  } else if (d <= 1 && _ > 1) {
    c = t - 1;
    const b = c - n + 4;
    m = o(b, i - 1);
  } else if (_ <= 1 && d <= 1)
    return L(1, t + 1);
  _ = m - 2, d = t - 1 - c;
  const s = [1];
  return _ > 1 ? s.push(I) : _ === 1 && s.push(2), s.push(...L(m, c + 1)), d > 1 ? s.push(I) : d === 1 && s.push(t - 1), s.push(t), s;
}, A = ({
  totalPages: n,
  activePage: i,
  visiblePages: t,
  disableScrollTarget: l = !1,
  onPageChange: o,
  onPagePrefetch: r,
  scrollTarget: p,
  className: u,
  hasMarginTop: m = !1,
  ariaLabels: c = {}
}) => {
  const {
    navigationLabel: _ = "Search navigation",
    previousPageLabel: d = "Previous page",
    nextPageLabel: s = "Next page",
    pageLabel: b = "Page",
    currentPageLabel: U = "current page",
    pageStatusLabel: y = "Page {current} of {total}"
  } = c, h = Math.max(Math.ceil(n), 1);
  if (h === 1)
    return null;
  const N = (f) => {
    i !== f && (o && o(f), !l && (p == null || p.scrollIntoView({ behavior: "smooth", block: "start" })));
  }, M = G(t, i, h).map((f, E) => {
    if (f === I)
      return /* @__PURE__ */ e(C, { index: E }, `ellipsis-${E}`);
    const x = f;
    return /* @__PURE__ */ e(
      j,
      {
        page: x,
        isActive: x === i,
        setPage: N,
        focusPage: r,
        pageLabel: b,
        currentPageLabel: U
      },
      x
    );
  });
  return /* @__PURE__ */ $(
    "nav",
    {
      className: g(a.pagination, m && a["pagination--has-margin-top"], u),
      "aria-label": _,
      children: [
        /* @__PURE__ */ e("div", { role: "status", "aria-live": "polite", "aria-atomic": "true", className: a["pagination__visually-hidden"], children: y.replaceAll("{current}", `${i}`).replaceAll("{total}", `${h}`) }),
        /* @__PURE__ */ $("ol", { className: a.pagination__row, children: [
          /* @__PURE__ */ e(
            S,
            {
              enabled: i !== 1,
              onClick: () => {
                i > 1 && N(i - 1);
              },
              onFocus: () => {
                r && i > 1 && r(i - 1);
              },
              icon: "chevron-left",
              label: d
            }
          ),
          M,
          /* @__PURE__ */ e("li", { className: g(a.pagination__item, a["pagination__small-numbers"]), "aria-hidden": "true", children: /* @__PURE__ */ $("span", { className: a["pagination__item-text"], children: [
            i,
            " ",
            /* @__PURE__ */ e("span", { className: a.pagination__separator }),
            " ",
            h
          ] }) }),
          /* @__PURE__ */ e(
            S,
            {
              enabled: i !== h,
              onClick: () => {
                i < h && N(i + 1);
              },
              onFocus: () => {
                r && i < h && r(i + 1);
              },
              icon: "chevron-right",
              label: s
            }
          )
        ] })
      ]
    }
  );
};
export {
  A as RocheUIPagination,
  G as getItemsWithEllipsis,
  L as range
};
